
export enum LevelType {
  Level1 = 'level1',
  Level2 = 'level2'
}
